import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = "27720286584";
const WHATSAPP_MESSAGE = "Hi, I'm interested in learning more about #MyLifeMatters";

export const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  const handleClick = () => {
    // Track click event (placeholder for analytics)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'click_whatsapp', {
        event_category: 'engagement',
        event_label: 'whatsapp_floating_button'
      });
    }
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 whatsapp-pulse group"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat on WhatsApp"
    >
      <div className="flex items-center gap-2 pl-4 pr-5 py-3">
        <MessageCircle className="w-6 h-6" fill="white" />
        <span className="font-semibold text-sm hidden sm:block">Chat with us</span>
      </div>
    </a>
  );
};

export default WhatsAppButton;
